/* web/app/components/style-guide/style-guide.component.scss */
.section {
  border-bottom: 2px solid #eee;
  padding: 50px 0 20px;
}
.sub-section {
  margin-bottom: 50px;
  color: #333333;
}
.title {
  font-size: 30px;
  margin-bottom: 30px;
}
.sub-title {
  font-size: 20px;
  margin-bottom: 15px;
  color: #9D9D9D;
}
.colors-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  margin-right: 70px;
}
.box {
  width: 66px;
  height: 66px;
  border-radius: 6px;
}
.gradient-box {
  width: 306px;
  height: 66px;
  border-radius: 6px;
}
.gradient-line {
  width: 306px;
  border-bottom: 3px solid;
}
.info-box {
  border: 1px solid #888;
  background: #F5F5F5;
  border-radius: 6px;
  padding: 20px 30px;
  direction: ltr;
  text-align: left;
  max-width: 100%;
}
.ltr {
  direction: ltr;
  text-align: left;
}
.highlight {
  background: pink;
  color: #94001a;
  font-family: Helvetica;
  font-size: 0.8rem;
}
/*# sourceMappingURL=style-guide.component.css.map */
